// @flow
import React from 'react';
import styled from 'styled-components';
import keycodes from '../../utils/keycodes';

const SearchDropDown = styled.div`
  position: absolute;
  right: 0px;
  z-index: 10;
  display: flex;
  top: 67px;
  background: black;
  padding: 12px 24px 12px 13px;
  border-bottom-left-radius: 10px;
`;
type Props = {
  searchModeEnabled: boolean,
  searchQuery: string,
  scribeExitSearchMode: Function,
  scribeUpdateSearchQuery: Function,
  scribePreviousSearchMatch: Function,
  scribeNextSearchMatch: Function,
  scribeSelectTranscriptWord: Function,
  searchMatches: Array<Object>,
  selectedSearchMatchIndex: number,
};

export default class ScribeSearchInput extends React.Component<Props> {
  $input: ?HTMLElement;

  setupInput = (el?: HTMLElement | null) => {
    if (!el) return;

    this.$input = el;
  };

  inputKeyDown = (ev: KeyboardEvent) => {
    const {
      selectedSearchMatchIndex,
      scribePreviousSearchMatch,
      searchMatches,
      scribeExitSearchMode,
      scribeNextSearchMatch,
      scribeSelectTranscriptWord,
    } = this.props;

    const key = keycodes(ev);
    if (key.SHIFT && key.TAB) {
      ev.preventDefault();
      ev.stopPropagation();
      if (selectedSearchMatchIndex === 0) return;

      scribePreviousSearchMatch();
    } else if (key.ESC) {
      ev.preventDefault();
      ev.stopPropagation();
      if (this.$input) this.$input.blur();
      scribeExitSearchMode();
    } else if (key.TAB) {
      ev.preventDefault();
      ev.stopPropagation();
      if (selectedSearchMatchIndex >= searchMatches.length - 1) return;
      scribeNextSearchMatch();
    } else if (key.RETURN) {
      ev.preventDefault();
      ev.stopPropagation();
      if (!searchMatches.length) return;
      const searchMatch = searchMatches[selectedSearchMatchIndex];

      // TODO: Find out why there is sometimes not a search match here
      if (!searchMatch) return;

      const { transcriptId, index } = searchMatch;

      scribeSelectTranscriptWord({
        index,
        indexTranscript: transcriptId,
      });
    }
  };
  // When we go from disabled to endabled
  // Deselect selected word
  // focus the input

  // When input loses focus, turn off search
  componentDidUpdate(prevProps: Props) {
    const { searchModeEnabled } = this.props;
    if (!prevProps.searchModeEnabled && searchModeEnabled) {
      if (this.$input) this.$input.focus();
    }
  }

  render() {
    const {
      searchQuery,
      scribeUpdateSearchQuery,
      searchModeEnabled,
      scribeExitSearchMode,
    } = this.props;

    if (!searchModeEnabled) return null;

    return (
      <SearchDropDown>
        <div
          style={{
            background: 'white',
            borderRadius: 5,
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          {/* eslint-disable-next-line */}
          <span
            style={{
              position: 'absolute',
              top: 8,
              left: 7,
            }}
          >
            <i className="material-icons" style={{ color: '#4C4C4C' }}>
              search
            </i>
          </span>
          <input
            type="text"
            style={{
              fontSize: 20,
              padding: '5px 10px 5px 36px',
              border: 'none',
            }}
            ref={this.setupInput}
            onBlur={() => scribeExitSearchMode()}
            value={searchQuery}
            onKeyDown={this.inputKeyDown}
            onChange={(ev: SyntheticEvent<HTMLInputElement>) => {
              scribeUpdateSearchQuery(
                (ev.target: window.HTMLInputElement).value
              );
            }}
          />
        </div>
      </SearchDropDown>
    );
  }
}
